module.exports = __webpack_public_path__ + "images/641cdf64.jpg";